/* eslint-disable */
import jQuery from "jquery";
import $ from "jquery";
import WOW from 'wowjs';
require('readmore-js');

(function ($, window, document)
{

    if ($('div').hasClass("paci_")) {
        neon_hexagon_particles_2(c, 1.4, 1.5, "#203AFF")
        neon_hexagon_particles_2(c2, 3.5, 3, "#C000FF")
        neon_hexagon_particles_2(c3, 1.4, 1.5, "#203AFF")
        neon_hexagon_particles_2(c4, 3.5, 3, "#C000FF")
        neon_hexagon_particles_2(c5, 1.4, 1.5, "#203AFF")
        neon_hexagon_particles_2(c6, 3.5, 3, "#C000FF")
        $('.js-readmore').readmore({
            collapsedHeight: 130,
            speed: 75,
            lessLink: '<a href="#">Read less</a>'
        });
    }


    // Stick header
    var stick_header = $('.header.-fix')
    if (stick_header.length) {
        if (stick_header.offset().top >= 100) stick_header.addClass("is-sticky");
        $(window).scroll(function ()
        {
            $(this).scrollTop() > 20 ? stick_header.addClass("is-sticky") : stick_header.removeClass("is-sticky")
        })
    }
    /*
    ======================================
    [ Back to top ]
    ======================================
    */

    var back_to_top = $(".sc-scrolltop"), offset = 220, duration = 500; $(window).scroll(function () { $(this).scrollTop() > offset ? back_to_top.addClass("is-active") : back_to_top.removeClass("is-active") }), $(document).on("click", ".sc-scrolltop", function (o) { return o.preventDefault(), $("html, body").animate({ scrollTop: 0 }, duration), !1 });


    //-------------------------------------------------
    // Menu Mobile
    //-------------------------------------------------
    $.fn.dnmenu = function (options)
    {

        let thiz = this
        let menu = $(this).attr('data-id')
        let menu_id = '#' + menu

        // Default options
        var settings = $.extend({
            name: 'Menu'
        }, options);

        // get ScrollBar Width
        function getScrollBarWidth()
        {
            var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
                widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
            $outer.remove();
            return 100 - widthWithScroll;
        };
        let ScrollBarWidth = getScrollBarWidth() + 'px';

        // Create wrap
        // Button click
        thiz.click(function (e)
        {

            e.preventDefault()
            if ($(this).hasClass('active')) {
                $(this).removeClass('active')
                $('body').removeClass('modal-open')
                $(menu_id).removeClass('active')

            } else {
                $(this).addClass('active')
                $('body').addClass('modal-open')
                $(menu_id).addClass('active')

            }
        });

        // Custom close
        $('.js-menu__close').click(function ()
        {
            $('body').removeClass('modal-open')
            $(thiz).removeClass('active')
            $(menu_id).removeClass('active')
        })

        // Menu
        var el = $(menu_id).find(".nav-mobile--ul");
        el.find(".menu-item-has-children>a").after('<button class="nav-mobile__btn"><i class="icon-arrow-down"></i></button>'),

            el.find(".nav-mobile__btn").on("click", function (e)
            {
                e.stopPropagation(),
                    $(this).parent().find('.sub-menu').first().is(":visible") ? $(this).parent().removeClass("sub-active") :
                        $(this).parent().addClass("sub-active"),
                    $(this).parent().find('.sub-menu').first().slideToggle()
            })

        $('.nav-mobile, .menu-mb__btn').mousedown(function (e) { e.stopPropagation(); });
        $(document).mousedown(function (e) { $('.nav-mobile').removeClass('active'); $(thiz).removeClass('active'); $("body").removeClass('modal-open') });

        // Apply options
        return;
    };

    $('.menu-mb__btn').dnmenu()
    /*=====  End of Menu  ======*/





})(jQuery, window, document);

(function ($, window, document)
{

    $('[data-toggle]').on('click', function (event)
    {
        event.preventDefault();
        var target = $(this.hash);
        target.toggle();
    });

    // Cache selectors
    var lastId,
        topMenu = $(".header .main__nav, .nav-mobile--ul"),
        topMenuHeight = topMenu.outerHeight() + 50,
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function ()
        {
            var item = $(this).attr("href");
            if (item != '#' && item != '/') {
                return $(item)
            }
        });

    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function (e)
    {
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
        $('html, body').stop().animate({
            scrollTop: offsetTop
        }, 300);
        e.preventDefault();
    });

    // Bind to scroll
    $(window).scroll(function ()
    {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function ()
        {
            if ($(this).offset() && $(this).offset().top < fromTop)
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id && id != '') {
            lastId = id;

            // Set/remove active class

            menuItems
                .closest('li').removeClass("active")
                .end().filter("[href='#" + id + "']").closest('li').addClass("active");

        }
    });
})(jQuery, window, document);


function neon_hexagon_particles(cavas_id, cx_point = 1.4, cy_point = 1.5)
{
    var w = cavas_id.width = window.innerWidth,
        h = cavas_id.height = window.innerHeight,
        ctx = cavas_id.getContext('2d'),

        opts = {

            len: 20,
            count: 50,
            baseTime: 10,
            addedTime: 10,
            dieChance: .05,
            spawnChance: 1,
            sparkChance: .1,
            sparkDist: 10,
            sparkSize: 2,

            color: '#B80B68',
            baseLight: 50,
            addedLight: 10, // [50-10,50+10]
            shadowToTimePropMult: 6,
            baseLightInputMultiplier: .01,
            addedLightInputMultiplier: .02,

            cx: w / cx_point,
            cy: h / cy_point,
            repaintAlpha: .04,
            hueChange: .1
        },

        tick = 0,
        lines = [],
        dieX = w / 2 / opts.len,
        dieY = h / 2 / opts.len,

        baseRad = Math.PI * 2 / 6;

    ctx.fillStyle = '';
    ctx.fillRect(0, 0, w, h);

    function loop()
    {

        window.requestAnimationFrame(loop);

        ++tick;

        ctx.globalCompositeOperation = 'source-over';
        ctx.shadowBlur = 0;
        ctx.fillStyle = 'rgba(0,0,0,alp)'.replace('alp', opts.repaintAlpha);
        ctx.fillRect(0, 0, w, h);
        ctx.globalCompositeOperation = 'lighter';

        if (lines.length < opts.count && Math.random() < opts.spawnChance)
            lines.push(new Line);

        lines.map(function (line) { line.step(); });
    }
    function Line()
    {

        this.reset();
    }
    Line.prototype.reset = function ()
    {

        this.x = 0;
        this.y = 0;
        this.addedX = 0;
        this.addedY = 0;

        this.rad = 0;

        this.lightInputMultiplier = opts.baseLightInputMultiplier + opts.addedLightInputMultiplier * Math.random();

        this.color = opts.color.replace('hue', tick * opts.hueChange);
        this.cumulativeTime = 0;

        this.beginPhase();
    }
    Line.prototype.beginPhase = function ()
    {

        this.x += this.addedX;
        this.y += this.addedY;

        this.time = 0;
        this.targetTime = (opts.baseTime + opts.addedTime * Math.random()) | 0;

        this.rad += baseRad * (Math.random() < .5 ? 1 : -1);
        this.addedX = Math.cos(this.rad);
        this.addedY = Math.sin(this.rad);

        if (Math.random() < opts.dieChance || this.x > dieX || this.x < -dieX || this.y > dieY || this.y < -dieY)
            this.reset();
    }
    Line.prototype.step = function ()
    {

        ++this.time;
        ++this.cumulativeTime;

        if (this.time >= this.targetTime)
            this.beginPhase();

        var prop = this.time / this.targetTime,
            wave = Math.sin(prop * Math.PI / 2),
            x = this.addedX * wave,
            y = this.addedY * wave;

        ctx.shadowBlur = prop * opts.shadowToTimePropMult;
        ctx.fillStyle = ctx.shadowColor = this.color.replace('light', opts.baseLight + opts.addedLight * Math.sin(this.cumulativeTime * this.lightInputMultiplier));
        ctx.fillRect(opts.cx + (this.x + x) * opts.len, opts.cy + (this.y + y) * opts.len, 2, 2);

        if (Math.random() < opts.sparkChance)
            ctx.fillRect(opts.cx + (this.x + x) * opts.len + Math.random() * opts.sparkDist * (Math.random() < .5 ? 1 : -1) - opts.sparkSize / 2, opts.cy + (this.y + y) * opts.len + Math.random() * opts.sparkDist * (Math.random() < .5 ? 1 : -1) - opts.sparkSize / 2, opts.sparkSize, opts.sparkSize)
    }
    loop();

    window.addEventListener('resize', function ()
    {

        w = cavas_id.width = window.innerWidth;
        h = cavas_id.height = window.innerHeight;
        ctx.fillStyle = 'black';
        ctx.fillRect(0, 0, w, h);

        opts.cx = w / 2;
        opts.cy = h / 2;

        dieX = w / 2 / opts.len;
        dieY = h / 2 / opts.len;
    });
}


function neon_hexagon_particles_2(c, cx_point = 1.4, cy_point = 1.5, color)
{
    var w = c.width = window.innerWidth,
        h = c.height = window.innerHeight,
        ctx = c.getContext('2d'),

        opts = {

            len: 20,
            count: 50,
            baseTime: 10,
            addedTime: 10,
            dieChance: .05,
            spawnChance: 1,
            sparkChance: .1,
            sparkDist: 10,
            sparkSize: 2,

            color: color,
            baseLight: 50,
            addedLight: 10, // [50-10,50+10]
            shadowToTimePropMult: 6,
            baseLightInputMultiplier: .01,
            addedLightInputMultiplier: .02,

            cx: w / cx_point,
            cy: h / cy_point,
            repaintAlpha: .04,
            hueChange: .1
        },

        tick = 0,
        lines = [],
        dieX = w / 2 / opts.len,
        dieY = h / 2 / opts.len,

        baseRad = Math.PI * 2 / 6;

    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, w, h);

    function loop()
    {

        window.requestAnimationFrame(loop);

        ++tick;

        ctx.globalCompositeOperation = 'source-over';
        ctx.shadowBlur = 0;
        ctx.fillStyle = 'rgba(0,0,0,alp)'.replace('alp', opts.repaintAlpha);
        ctx.fillRect(0, 0, w, h);
        ctx.globalCompositeOperation = 'lighter';

        if (lines.length < opts.count && Math.random() < opts.spawnChance)
            lines.push(new Line);

        lines.map(function (line) { line.step(); });
    }
    function Line()
    {

        this.reset();
    }
    Line.prototype.reset = function ()
    {

        this.x = 0;
        this.y = 0;
        this.addedX = 0;
        this.addedY = 0;

        this.rad = 0;

        this.lightInputMultiplier = opts.baseLightInputMultiplier + opts.addedLightInputMultiplier * Math.random();

        this.color = opts.color.replace('hue', tick * opts.hueChange);
        this.cumulativeTime = 0;

        this.beginPhase();
    }
    Line.prototype.beginPhase = function ()
    {

        this.x += this.addedX;
        this.y += this.addedY;

        this.time = 0;
        this.targetTime = (opts.baseTime + opts.addedTime * Math.random()) | 0;

        this.rad += baseRad * (Math.random() < .5 ? 1 : -1);
        this.addedX = Math.cos(this.rad);
        this.addedY = Math.sin(this.rad);

        if (Math.random() < opts.dieChance || this.x > dieX || this.x < -dieX || this.y > dieY || this.y < -dieY)
            this.reset();
    }
    Line.prototype.step = function ()
    {

        ++this.time;
        ++this.cumulativeTime;

        if (this.time >= this.targetTime)
            this.beginPhase();

        var prop = this.time / this.targetTime,
            wave = Math.sin(prop * Math.PI / 2),
            x = this.addedX * wave,
            y = this.addedY * wave;

        ctx.shadowBlur = prop * opts.shadowToTimePropMult;
        ctx.fillStyle = ctx.shadowColor = this.color.replace('light', opts.baseLight + opts.addedLight * Math.sin(this.cumulativeTime * this.lightInputMultiplier));
        ctx.fillRect(opts.cx + (this.x + x) * opts.len, opts.cy + (this.y + y) * opts.len, 2, 2);

        if (Math.random() < opts.sparkChance)
            ctx.fillRect(opts.cx + (this.x + x) * opts.len + Math.random() * opts.sparkDist * (Math.random() < .5 ? 1 : -1) - opts.sparkSize / 2, opts.cy + (this.y + y) * opts.len + Math.random() * opts.sparkDist * (Math.random() < .5 ? 1 : -1) - opts.sparkSize / 2, opts.sparkSize, opts.sparkSize)
    }
    loop();

    window.addEventListener('resize', function ()
    {

        w = c.width = window.innerWidth;
        h = c.height = window.innerHeight;
        ctx.fillStyle = 'black';
        ctx.fillRect(0, 0, w, h);

        opts.cx = w / 2;
        opts.cy = h / 2;

        dieX = w / 2 / opts.len;
        dieY = h / 2 / opts.len;
    });
}

